/**
 * This file was generated by Itecho.TSGen tool
 * Version and info generated in .version
 * Any changes to this file will be lost if regenerated 
 */

enum YieldWeightUnit {
    Kg = "Kg",
    Ton = "Ton",
    TonPerHa = "TonPerHa",
    TotaleKartonne = "TotaleKartonne",
    KartonnePerHa = "KartonnePerHa",
    TotaleBins = "TotaleBins",
    BinsPerHa = "BinsPerHa"
}
export default YieldWeightUnit